import { z } from 'zod';

export const usStateValidationMessages = {
  invalid: 'Select a valid state',
  required: 'Required',
};

export const usStateSchema = z
  .string()
  .min(1, { error: usStateValidationMessages.required })
  .length(2, { error: usStateValidationMessages.invalid });
